import { OktaAuth } from '@okta/okta-auth-js';

import routes from '@/routes/config';

const ISSUER = import.meta.env.VITE_OKTA_AUTH_ISSUER;
const CLIENT_ID = import.meta.env.VITE_OKTA_AUTH_CLIENT_ID;
const BASE_URL = import.meta.env.VITE_APP_BASE_URL;

// autoRenew:true handles in-session expiry (typically every 1 hour) without user interaction.
// The `offline_access` scope is required for refresh token issuance.
// IMPORTANT: Any auth initialisation code that runs on mount must NOT call Okta's /userinfo
// endpoint — that would blow through Okta's rate limit for orgs with many concurrent users.
// Read claims (sub, roles, etc.) directly from the access token instead.
// See AuthProvider.tsx → initializeAuth.

const oktaAuth = new OktaAuth({
  issuer: ISSUER,
  clientId: CLIENT_ID,
  redirectUri: `${BASE_URL}${routes.login.callback}`,
  scopes: ['openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  responseType: ['token', 'id_token'],
  tokenManager: {
    autoRenew: true
  },
  storageManager: {
    token: {
      storageType: 'localStorage'
    },
    cache: {
      storageType: 'localStorage'
    },
    transaction: {
      storageType: 'localStorage'
    }
  }
});

export default oktaAuth;
